import { DateTime } from "luxon";
import { formatTime } from "lib/formatDateTime";

// The Sangra 75 pilot books a 90-minute slot instead of the usual 60, with
// the blood draw ahead of the scan. The scan routine starts 40 minutes in.
const SCAN_ROUTINE_OFFSET_MINUTES = 40;

export function extendedVisitRecommendedScanStartTime({
  startTime,
  countryCode,
}: {
  startTime: DateTime;
  countryCode: string | undefined;
}): string {
  return formatTime(
    startTime.plus({ minutes: SCAN_ROUTINE_OFFSET_MINUTES }),
    countryCode
  );
}
